import {Box, Stack, Typography} from '@mui/material';
import {Loader} from '@kei.fi/core-ui';

export interface LoadingPageProps {
  title?: string;
  size?: number;
}

export const LoadingPage = ({title}: LoadingPageProps) => {
  return (
    <Stack height="100%">
      {title && (
        <Typography variant="h3" textAlign="center" my={3}>
          {title}
        </Typography>
      )}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        paddingY="4rem"
        flexGrow={1}
      >
        <Loader size="5rem" />
      </Box>
    </Stack>
  );
};
